<section id="semantics" class=" text-center">
  <div class="row">
    <div class="col-5">
      <button class="operationSpeechButton" (click)="clearText()">
        <img class="operationSpeechImageButton" src="assets/speech/clear.svg" alt="Save">
      </button>
        <!--      <button  type="button" class="analysisButton" (click)="analysis()">Analysis</button>-->
        <button title="It has been deactivated." type="button" class="analysisButton disabl">Analysis</button>
    </div>
    <div class="col-2">
      <p>Please select your language:</p>
      <input type="radio" id="gr" name="language" value="gr" checked style=" display: inline;"
             (change)="changeLanguage('gr')">
      <label style=" display: inline;" for="gr">Greek</label> &nbsp;
      <input style=" display: inline;" type="radio" id="en" name="language" value="en" (change)="changeLanguage('en')">
      <label style=" display: inline;" for="en">English</label>
    </div>
    <div class="col-5">
      <button (click)="startSpeech()"
              class="mytooltip actionButton">
        <span id="info" class="tooltiptext"></span>
        <img id="start_img" src="assets/speech/speech.webp" height="38" width="38" alt="Start"/>
      </button>
    </div>
  </div>
  <div>
  </div>
  <hr/>
  <div class="md-form" style="position: relative;min-height: 40px">
    <h5>Interim text</h5>
    [ <span style="color: lightgray; min-height: auto" id="textInterim"></span> ]
  </div>
  <div class="md-form" style="position: relative;height: auto; max-height: 200px;overflow-y:scroll;">
    <h5 align="left">Enter your text</h5>
    <textarea type="text" id="text" class="md-textarea md-textarea-auto form-control" [(ngModel)]="text"
              style="margin:auto" mdbInput></textarea>

  </div>
  <hr/>
  <div class="loader" [style.visibility]="semanticsService.isBusy? 'visible': 'hidden'">
  </div>
  <div class="row">
    <div class="col-4">
      <h5>Indicators</h5>
      <div style="position: relative;height: auto; max-height: 300px;" *ngIf="results">
        Polarity: {{results['polarity']}}<br/>
        Sentiment: {{results['sentiment']}}<br/>

        <h6><u>Sentics</u></h6>
        <span *ngIf="results['sentics']['aptitude']"> Aptitude: {{results['sentics']['aptitude']}}<br/></span>
        <span *ngIf="results['sentics']['attention']"> Attention: {{results['sentics']['attention']}}<br/></span>
        <span *ngIf="results['sentics']['pleasantness']"> Pleasantness: {{results['sentics']['pleasantness']}}
          <br/></span>
        <span *ngIf="results['sentics']['sensitivity']"> Sensitivity: {{results['sentics']['sensitivity']}}<br/></span>
      </div>
    </div>

    <div class="col-4">
      <h5>Mood tags</h5>
      <div style="position: relative;;height: auto; max-height: 250px;" *ngIf="results && results['moodtags']">
        {{results['moodtags'] | json}}
      </div>
    </div>

    <div class="col-4">
      <h5>Semantics</h5>
      <div style="position: relative;height: auto; max-height: 250px;overflow-y: scroll;"
           *ngIf="results && results['semantics']">
        <table>
          <tbody>
          <tr *ngFor="let semantic of results['semantics'];let i = index">
            <td># {{i}}</td>
            <td>{{semantic}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- <div class="md-form" style="height: auto">
     <textarea type="text" id="results" [(ngModel)]="resultsStr" readonly class="md-textarea md-textarea-auto form-control"
               mdbInput></textarea>
   </div>-->
</section>

